import React from 'react'
import cx from 'classnames'
import prefix from 'utils/prefix'
import './styles.sass'

const tabModifiers = prefix('mini-tabs__tab--')

export const MiniTabs = ({ children, className, ...rest }) => (
  <div className={cx('mini-tabs', className)} {...rest}>
    {children}
  </div>
)

export const MiniTab = ({ children, active, className, ...rest }) => (
  <a className={cx('mini-tabs__tab', tabModifiers({ active }), className)} {...rest}>
    {children}
  </a>
)



// WEBPACK FOOTER //
// ./src/client/components/MiniTabs/index.jsx